import { RouteConfig } from 'vue-router';
import ConsultaJurisprudenciaSelecionada from '@/views/jurisprudencia-selecionada/ConsultaJurisprudenciaSelecionada.vue';

const baseRouterLink = '/jurisprudencia-selecionada';

const ConsultaJurisprudenciaSelecionadaRoutes: RouteConfig[] = [
  {
    path: `${baseRouterLink}/consulta`,
    name: 'consulta-jurisprudencia-selecionada',
    component: ConsultaJurisprudenciaSelecionada,
  },
];

export default ConsultaJurisprudenciaSelecionadaRoutes;
